import { ReactElement } from "react";

export default function PrivacyPolicy(): ReactElement {
  return (
    <main className="max-w-4xl mx-auto px-6 py-6 pb-12">

      <h1 className="text-5xl font-thin uppercase mb-6">
        Privacy Policy
      </h1>

      <p className="text-xl mt-12 mb-6">
        Last updated: 18 October 2025
      </p>

      <p>
        This website is operated by Pressing Space Ltd, the data controller for your personal information.
        You can contact us at
        {" "}
        <a href="mailto:hello@yomidi.com" className="underline text-blue-600 hover:text-blue-800">
          hello@yomidi.com
        </a>.
      </p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">1. Information We Collect</h2>
      <ul className="list-disc list-inside">
        <li>Email addresses you provide through forms.</li>
        <li>App-related data you choose to submit.</li>
        <li>Usage data collected via Google Analytics.</li>
      </ul>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">2. Legal Basis for Processing</h2>
      <p>We process your data:</p>
      <ul className="list-disc list-inside">
        <li>With your consent (when you submit forms).</li>
        <li>Under legitimate interest (to operate and protect the site).</li>
      </ul>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">3. How We Use Your Data</h2>
      <p>To operate the service, communicate with you, prevent spam, and understand site usage.</p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">4. Data Storage and Transfers</h2>
      <p>We use Supabase to store data, which may be located outside the UK.</p>
      <p>Where data is transferred internationally, we rely on GDPR-compliant safeguards such as Standard Contractual Clauses.</p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">5. Third-Party Services</h2>
      <p>We use:</p>
      <ul className="list-disc list-inside">
        <li>Supabase (database and authentication)</li>
        <li>Google Analytics (site usage tracking)</li>
      </ul>
      <p>Each provider processes data under their own privacy policies.</p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">6. Retention</h2>
      <p>We keep your data only as long as needed for the purpose it was collected or until you ask us to delete it.</p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">7. Your Rights</h2>
      <p>
        You can request access, correction, or deletion of your personal data by contacting
        {" "}
        <a href="mailto:hello@yomidi.com" className="underline text-blue-600 hover:text-blue-800">hello@yomidi.com</a>.
      </p>

      <h2 className="text-2xl font-thin uppercase mt-12 mb-6">8. Cookies</h2>
      <p>
        We use cookies for Google Analytics.
      </p>
      <p className="mt-4">
        <strong>Analytics cookies are only set after you explicitly accept them.</strong> We use Google's Consent Mode v2
        to ensure no analytics data is collected or sent to Google Analytics until you click "Accept" on our cookie banner.
        Before consent, the analytics script loads but all tracking is disabled.
      </p>
      <p className="mt-4">
        You can manage or withdraw consent at any time by clearing your browser's local storage or cookie settings.
      </p>

    </main>
  );
}
